import React, { Component } from 'react';
import { Grid, Dropdown, Form, Segment, Menu, Tab, Button, Icon, Modal } from 'semantic-ui-react';
import { getClientAlertsInfo, resolveSuit, resolveDoc, exportXLSX, getClientAlertsHistory, uploadDocuments, getDashBoardDetails, postAccountPayment } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import Docs from './Docs';
import Suit from './Suit';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
import PaymentTab from '../payments/PaymentTab';
import AddComment from './AddComment';
import validation from '../../components/SimpleReactValidation';

class ClientAlert extends Component {
    constructor(props) {
        super(props);
        this.validator = validation();
        this.state = {
            activeIndex: 0,
            loading: false,
            docDetails: [],
            actionDetails: [],
            paymentDetails: [],
            searchIndex: {
                cltClientIds: []
            },
            document: {
                data: []
            },
            suit: {
                data: [],
                authSuit: false,
            },
            paymentInfo: {
                openAllocation: false,
                allocationResult: {},
                paymentAmount: 0,
                adjustmentAmount: 0,
                paymentDate: "",
                adjustmentDate: "",
                paymentType: "",
                adjustmentType: "",
            },
            expanded: {},
            history: [],
            openMsg7: false,
            openDocs: false,
            openSuit: false,
            openMsg12: false,
            openMsg12a: false,
            openComment: false,
            message12Content: "",
            postItems: {}
        };
    }

    componentDidMount() {

        this.props.addItem("helpFile", "am_client-requests.md");
        this.getClientAlerts();
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.getClientAlerts();
        }
    }

    handleChange = (evt, e) => {
        evt.preventDefault();
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                cltClientIds: e.value
            }
        })
    }

    handlePayment = (paymentInfo) => {
        this.setState({
            //loading: true
        }, () => {
            let data = {
                cltClientId: paymentInfo.cltClientId,
                conConsumerId: paymentInfo.conConsumerId,
                acoAccountId: paymentInfo.acoAccountId,
                acoInvoiceId: paymentInfo.acoInvoiceId,
                conFirstName: paymentInfo.conFirstName,
                conLastName: paymentInfo.conLastName,
                paymentAmount: paymentInfo.paymentAmount,
                paymentDate: paymentInfo.paymentDate,
                paymentType: paymentInfo.paymentType,
                adjustmentAmount: paymentInfo.adjustmentAmount,
                adjustmentDate: paymentInfo.adjustmentDate,
                adjustmentType: paymentInfo.adjustmentType
            }
            postAccountPayment(this.props.items.currentCorporate, true, data).then((response) => {
                if (response !== null) {
                    paymentInfo.comment = "Resolved by posting Direct Payment/Adjustment";
                    this.resolvePayment(paymentInfo);
                }
            }).then(() => {
                this.setState({
                    // loading: false
                })
            });
        });
    }

    resolvePaymentWithComment = (comment) => {
        let paymentInfo = Object.assign(this.state.postItems, comment);
        this.resolvePayment(paymentInfo);
    }

    resolvePayment = (paymentInfo) => {

        resolveDoc(this.props.items.currentCorporate, paymentInfo).then((response) => {
            if (response !== null) {
                let paymentDetails = this.state.paymentDetails.filter((req) => {
                    return req.documentId !== paymentInfo.documentId
                });
                this.setState({
                    paymentDetails,
                    postItems: {},
                    openMsg7: true,
                    loading: false,
                    openComment: false
                });
                getDashBoardDetails(this.props.items.currentCorporate).then((response) => {
                    if (response !== null && (response instanceof Object)) {
                        this.props.addItem("countDetails", response);
                    }
                });
            }
        }).then((error) => {
            this.setState({
                loading: false,
                openMsg12: false,
            })
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.getClientAlerts();
    }

    getClientAlerts = () => {
        this.setState((prevState, props) => {
            return { loading: true };
        }, () => {
            getClientAlertsInfo(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                if (response !== null && response instanceof Array) {
                    this.setState({
                        loading: false,
                        actionDetails: response.filter((action) => {
                            return action.requestDoc === 'H'
                        }),
                        docDetails: response.filter((action) => {
                            return action.requestDoc !== 'H' && action.requestDoc !== 'DP'
                        }),
                        paymentDetails: response.filter((action) => {
                            return action.requestDoc === 'DP'
                        })
                    })
                }
            }).then(() => {
                this.setState((prevState, props) => {
                    return { loading: false };
                });
            })
        });
    }

    close = () => {
        this.setState({
            openDocs: false,
            openSuit: false,
            openMsg7: false,
            openComment: false
        })
    }

    openMsg12a = () => {
        this.setState({
            openMsg12a: true,
            message12Content: "Upload atleast one document!"
        })
    }

    openComment = (paymentInfo) => {
        this.setState({
            openComment: true,
            postItems: paymentInfo
        })
    }

    closeMessage = () => {
        this.setState({
            openMsg7: false,
            openMsg12: false,
            openMsg12a: false,
        })
    }

    setDocsDetails = (row) => {
        this.setState({
            openDocs: true,
            document: {
                ...this.state.document,
                data: row
            }
        }, () => this.getHistory(row))
    }

    setSuitDetails = (row) => {
        this.setState({
            openSuit: true,
            suit: {
                ...this.state.suit,
                data: row
            }
        }, () => this.getHistory(row))
    }

    getHistory = (row) => {
        getClientAlertsHistory(this.props.items.currentCorporate, row.conConsumerId, row.acoAccountId).then((response) => {
            if (response !== null && response instanceof Array) {
                this.setState({
                    history: response
                });
            }
        });
    }

    getDocDesc = (t) => {
        switch (t) {
            case 'A': return "Assignment"
            case 'C': return "Contracts"
            case 'S': return "Statement"
            case 'O': return "Others"
            default: return "";
        }

    }

    suitYesNo = (YesNo) => {
        this.setState({
            suit: {
                ...this.state.suit,
                authSuit: YesNo
            }
        })
    }

    handleSuit = (data, comment, confirm) => {
        this.setState({
            openMsg12: confirm,
            message12Content: "Are you sure for the action : " + (this.state.suit.authSuit ? "Proceed with suit" : "Not Proceed with suit") + "?",
            postItems: Object.assign(data, { comment: comment, action: "suit" })
        }, () => {
            if (!confirm) {
                this.resolve();
            }
        });
    }

    handleDoc = (data, comment, confirm) => {
        this.setState({
            openMsg12: confirm,
            message12Content: "Are you sure for the action : " + comment + "?",
            postItems: Object.assign(data, { comment: comment, action: "doc" })
        }, () => {
            if (!confirm) {
                this.resolve();
            }
        });
    }

    resolve = () => {
        this.setState({
            loading: true
        }, () => {
            if (this.state.postItems && this.state.postItems.action === "doc") {
                resolveDoc(this.props.items.currentCorporate, this.state.postItems).then((response) => {
                    if (response !== null) {
                        let docDetails = this.state.docDetails.filter((doc) => {
                            return this.state.postItems.documentType === "G" || doc.documentId !== this.state.postItems.documentId
                        });
                        if (this.state.postItems.documentType === "G") {
                            this.getHistory(this.state.postItems);
                        }
                        this.setState({
                            docDetails,
                            postItems: {},
                            openMsg7: true,
                            openDocs: this.state.postItems.documentType === "G",
                            loading: false
                        });
                        getDashBoardDetails(this.props.items.currentCorporate).then((response) => {
                            if (response !== null && (response instanceof Object)) {
                                this.props.addItem("countDetails", response);
                            }
                        });
                    }
                }).then((error) => {
                    this.setState({
                        loading: false,
                        openMsg12: false,
                    })
                });
            } else {
                resolveSuit(this.props.items.currentCorporate, {
                    suit: this.state.suit.authSuit
                }, this.state.postItems).then((response) => {
                    if (response !== null) {
                        let actionDetails = this.state.actionDetails.filter((suit) => {
                            return this.state.postItems.documentType === "G" || suit.acoAccountId !== this.state.postItems.acoAccountId
                        });
                        if (this.state.postItems.documentType === "G") {
                            this.getHistory(this.state.postItems);
                        }
                        this.setState({
                            actionDetails,
                            openSuit: this.state.postItems.documentType === "G",
                            openMsg7: true,
                            loading: false
                        });
                        getDashBoardDetails(this.props.items.currentCorporate).then((response) => {
                            if (response !== null && (response instanceof Object)) {
                                this.props.addItem("countDetails", response);
                            }
                        });
                    }
                }).then((error) => {
                    this.setState({
                        loading: false,
                        openMsg12: false,
                    })
                });;
            }
        });
    }

    tabChange = (e, { activeIndex }) => {
        this.setState({ activeIndex })
    }

    resolveDocuments = (uploadDetails, acoAccountId) => {
        this.setState({
            loading: true,
        }, () => {
            if (uploadDetails.length) {
                uploadDocuments(this.props.items.currentCorporate, acoAccountId, uploadDetails).then((response) => {
                    if (response !== null) {
                        let docDetails = this.state.docDetails.filter((doc) => {
                            return doc.documentId !== uploadDetails[0].documentId
                        });
                        this.setState({
                            docDetails,
                            postItems: {},
                            openMsg7: true,
                            loading: false,
                            openDocs: false
                        });
                        getDashBoardDetails(this.props.items.currentCorporate).then((response) => {
                            if (response !== null && (response instanceof Object)) {
                                this.props.addItem("countDetails", response);
                            }
                        })
                    }
                }).then((error) => {
                    this.setState({
                        loading: false,
                        openMsg12: false,
                    })
                });
            } else {
                this.openMsg12a();
                this.setState({
                    loading: false
                })
            }
        });
    }

    getPanes = (panes) => {

        return panes.filter((p) => {
            if (p.menuItem.key === "legalRequest") {
                return this.props.config.LEGAL === 'Y' ? true : false;
            }
            return true;
        });
    }

    export = () => {

        let exportHeader = {};
        let exportData = [];
        switch (this.state.activeIndex) {
            case 0:
                exportHeader = {
                    "Client ID": "cltClientId",
                    "Consumer Name": "conLastName",
                    "Client Acct#": "acoInvoiceId",
                    "Our Acct#": "acoAccountId",
                    "DOS": "acoDateOfService",
                    "DOR": "acoDateReferred",
                    "Total": "acoTotal",
                    "Request Date": "requestDate",
                    "Docs Needed": "requestDoc"
                };
                exportData = this.state.docDetails;
                break;
            case 1:
                exportHeader = {
                    "Client ID": "cltClientId",
                    "Consumer Name": "conLastName",
                    "Client Acct#": "acoInvoiceId",
                    "Our Acct#": "acoAccountId",
                    "DOS": "acoDateOfService",
                    "DOR": "acoDateReferred",
                    "Total": "acoTotal",
                    "Request Date": "requestDate"
                };
                exportData = this.state.actionDetails;
                break;
            case 2:
                exportHeader = {
                    "Client ID": "cltClientId",
                    "Consumer Name": "conLastName",
                    "Client Acct#": "acoInvoiceId",
                    "Our Acct#": "acoAccountId",
                    "Total": "acoTotal",
                    "Request Date": "requestDate",
                    "Request Status": "documentStatus"
                };
                exportData = this.state.paymentDetails;
                break;
            default:
                exportHeader = {};
                exportData = {};

        }
        exportXLSX(exportHeader, exportData, "ClientAlert.xlsx");
    }

    render() {

        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        const panes = [
            {
                menuItem: (
                    <Menu.Item key='documentRequest'>
                        Document Requests&nbsp; <span style={{ color: "red" }}>[{this.state.docDetails.length}]</span>
                    </Menu.Item>
                ), pane: {
                    key: 'first', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.docDetails && this.state.docDetails.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.state.docDetails}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            columns={[{
                                Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                accessor: 'cltClientId',
                                width: 80
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Consumer’s First & Last Name" data-position="bottom left">Consumer Name</span>,
                                id: "conLastName",
                                // width: 270,
                                accessor: el => (el.conLastName + " " + el.conFirstName),
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                accessor: 'acoInvoiceId',
                                width: 150
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                accessor: 'acoAccountId',
                                width: 150
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Service" data-position="bottom left">DOS</span>,
                                id: 'acoDateOfService',
                                width: 100,
                                accessor: 'acoDateOfService'
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Referral" data-position="bottom left">DOR</span>,
                                id: 'acoDateReferred',
                                width: 100,
                                accessor: 'acoDateReferred'
                            }, {
                                Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Total</span>,
                                id: 'acoTotal',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoTotal, true)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date Our Request was Submitted" data-position="bottom left">Request Date</span>,
                                id: 'requestDate',
                                width: 100,
                                accessor: 'requestDate'
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Document Needed" data-position="bottom left">Docs Needed</span>,
                                id: 'requestDoc',
                                width: 125,
                                accessor: row => (
                                    row.ctdClrRemarks.length > 0 ?
                                        <span data-inverted="" id={row.ctdClrRemarks.length > 100 ? "alert-ctdClrRemarks" : ""} data-tooltip={row.ctdClrRemarks} data-position="bottom right">{row.isMatter === "Y" ? this.getDocDesc(row.requestDoc) : row.documentStatus}</span> :
                                        row.isMatter === "Y" ? this.getDocDesc(row.requestDoc) : row.documentStatus
                                ),
                            },
                            {
                                Header: props => <span data-inverted="" data-tooltip="Suit Matter" data-position="bottom left">Matter?</span>,
                                width: 60,
                                id: 'isMatter',
                                show: this.props.config.LEGAL === 'Y',
                                style: {
                                    textAlign: "center"
                                },
                                accessor: row => (
                                    row.isMatter === "Y" ? "Yes" : "No"
                                ),
                            },
                            {
                                Header: props => <span data-inverted="" data-tooltip="Resolve Action" data-position="top left">Resolve</span>,
                                style: {
                                    textAlign: "center"
                                },
                                filterable: false,
                                width: 60,
                                Cell: row => (
                                    <div>
                                        <Button onClick={() => { this.setDocsDetails(row.original) }} className="icon mini" data-inverted="" data-tooltip="Upload, Fax or Add Comment" data-position="top right" ><Icon name="file outline" /></Button>
                                    </div>
                                )
                            }]}
                        />
                    )
                }
            },
            {
                menuItem: (
                    <Menu.Item key='legalRequest'>
                        Legal Action Requests&nbsp; <span style={{ color: "red" }}>[{this.state.actionDetails.length}]</span>
                    </Menu.Item>
                ),
                pane: {
                    key: 'second', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.actionDetails && this.state.actionDetails.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.state.actionDetails}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            columns={[{
                                Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                accessor: 'cltClientId',
                                width: 100
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Consumer’s First & Last Name" data-position="bottom left">{this.props.t("consumer.name")}</span>,
                                id: 'conFirstName',
                                accessor: row => (
                                    row.conLastName + " " + row.conFirstName
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                accessor: 'acoInvoiceId',
                                width: 200
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                accessor: 'acoAccountId',
                                width: 150
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Service" data-position="bottom left">DOS</span>,
                                id: 'acoDateOfService',
                                width: 100,
                                accessor: 'acoDateOfService'
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date of Referral" data-position="bottom left">DOR</span>,
                                id: 'acoDateReferred',
                                width: 100,
                                accessor: 'acoDateReferred'
                            }, {
                                Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Total</span>,
                                id: 'acoTotal',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoTotal, true)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date Our Request was Submitted" data-position="bottom left">Request Date</span>,
                                id: 'requestDate',
                                width: 100,
                                accessor: 'requestDate'
                            }, {
                                filterable: false,
                                Header: props => <span data-inverted="" data-tooltip="Resolve Action" data-position="top right">Resolve</span>,
                                style: {
                                    textAlign: "center"
                                },
                                width: 130,
                                Cell: row => (
                                    <div>
                                        <Button onClick={() => { this.setSuitDetails(row.original) }} className="icon mini" data-inverted="" data-tooltip="Resolve Action" data-position="top right" >Autho Requested</Button>
                                    </div>
                                )
                            }]}
                        />
                    )
                },
            },
            {
                menuItem: (
                    <Menu.Item key='paymentRequest'>
                        DP/ADJ Inquiry&nbsp; <span style={{ color: "red" }}>[{this.state.paymentDetails.length}]</span>
                    </Menu.Item>
                ),
                pane: {
                    key: 'third', content: (
                        <ReactTable noDataText={null} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.paymentDetails && this.state.paymentDetails.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                            data={this.state.paymentDetails}
                            getNoDataProps={() => {
                                return { style: { display: 'none' } };
                            }}
                            collapseOnDataChange={false}
                            onExpandedChange={(expanded, index, event) => {
                                this.setState({
                                    expanded
                                });
                            }}
                            expanded={this.state.expanded}
                            SubComponent={
                                row => {
                                    let data = [];
                                    data.push(
                                        Object.assign(row.original, {
                                            acoDos: row.original.acoDateOfService
                                        })
                                    )
                                    return (
                                        <Segment.Group horizontal key={row.original.documentId}>
                                            <Segment>
                                                <PaymentTab {...this.props} data={data} handleSubmit={this.handlePayment} />
                                            </Segment>
                                        </Segment.Group>
                                    )
                                }
                            }
                            columns={[{
                                Header: props => <span data-inverted="" data-tooltip="Our Client Identifier" data-position="bottom left">Client ID</span>,
                                accessor: 'cltClientId',
                                width: 100
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Consumer’s First & Last Name" data-position="bottom left">{this.props.t("consumer.name")}</span>,
                                id: 'conFirstName',
                                accessor: row => (
                                    row.conLastName + " " + row.conFirstName
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Your Account Number for this Billing" data-position="bottom left">Client Acct#</span>,
                                accessor: 'acoInvoiceId',
                                width: 100
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Our Agency’s Account Number" data-position="bottom left">Our Acct#</span>,
                                accessor: 'acoAccountId',
                                width: 100
                            }, {
                                Header: props => <span style={{ textAlign: "right" }} data-inverted="" data-tooltip="Current Total Due" data-position="bottom left">Total</span>,
                                id: 'acoTotal',
                                width: 100,
                                style: {
                                    textAlign: "right"
                                },
                                accessor: row => (
                                    this.props._currencyFormat(row.acoTotal, true)
                                )
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Date Our Request was Submitted" data-position="bottom left">Request Date</span>,
                                id: 'requestDate',
                                width: 100,
                                accessor: 'requestDate'
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Request Status" data-position="bottom left">Status</span>,
                                accessor: 'documentStatus',
                                width: 200
                            }, {
                                Header: props => <span data-inverted="" data-tooltip="Client rep remarks" data-position="bottom left">Remarks</span>,
                                accessor: 'ctdClrRemarks',
                                width: 200
                            },
                            {
                                expander: true,
                                width: 80,
                                Header: props => <span data-inverted="" data-tooltip="Resolve by posting Payment/Adjustment" data-position="bottom right">Make Payment</span>,
                                Expander: ({ isExpanded, ...rest }) =>
                                    <div>
                                        {
                                            isExpanded
                                                ? <Icon className="arrow alternate circle down icon"></Icon>
                                                : <span data-inverted="" data-tooltip="Resolve by posting Payment/Adjustment" data-position="top right"><Icon className="arrow alternate circle left icon"></Icon></span>
                                        }
                                    </div>,
                                style: {
                                    cursor: "pointer",
                                    textAlign: "center"
                                }
                            }, {
                                filterable: false,
                                Header: props => <span data-inverted="" data-tooltip="Add a comment" data-position="bottom right">Add Comment</span>,
                                style: {
                                    textAlign: "center"
                                },
                                width: 90,
                                Cell: row => (
                                    <div>
                                        <Button onClick={() => { this.openComment(row.original) }} className="icon mini" data-inverted="" data-tooltip="Add a comment" data-position="top right" ><Icon name="comments outline"></Icon></Button>
                                    </div>
                                )
                            }]}
                        />
                    )
                },
            }
        ];
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Account Management" child={[{ name: "Client Alert", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={6}>
                                        <label>Select Client ID(s)</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients} name="cltClientIds" value={this.state.searchIndex.cltClientIds} onChange={this.handleChange}></Dropdown>
                                    </Form.Field>
                                    <Form.Field width={6}>
                                        <Button.Group width={2} className="small push-down">
                                            <Button onClick={() => this.setState((prevState, props) => {
                                                return {
                                                    searchIndex: {
                                                        cltClientIds: []
                                                    }
                                                };
                                            })}>{this.props.t("reset")}</Button>
                                            <Button.Or />
                                            <Button positive onClick={this.handleSubmit}>{this.props.t("submit")}</Button>
                                        </Button.Group>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <Segment.Group>
                                <Segment raised color="grey" inverted>
                                    <h4 className="ui header">
                                        <i className="bell open icon"></i>
                                        <div className="content">
                                            Client Alert
                                            </div>
                                    </h4>
                                </Segment>
                                <Grid>
                                    <Grid.Column width={1} floated='right' className="remvespace-btm">
                                        <Button onClick={this.export}
                                            className="ui left small icon button icon-export" data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                                            <i className="file excel icon"></i>
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                                <div className="push-up40">
                                    <Tab panes={this.getPanes(panes)} renderActiveOnly={false} onTabChange={this.tabChange} />
                                    <Docs {...this.props} getDocDesc={this.getDocDesc} open={this.state.openDocs} close={this.close} handleSubmit={this.handleDoc}
                                        sameAccountOtherDocs={this.state.docDetails.filter((doc) => {
                                            return doc.acoAccountId === this.state.document.data.acoAccountId
                                        })}
                                        history={this.state.history}
                                        data={this.state.document.data} openMsg12a={this.openMsg12a}
                                        resolveDocuments={this.resolveDocuments} />
                                    <Suit {...this.props} open={this.state.openSuit} history={this.state.history} close={this.close} data={this.state.suit.data} handleSubmit={this.handleSuit} suitYesNo={this.suitYesNo} authSuit={this.state.suit.authSuit} />
                                </div>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Modal size="small" open={this.state.openComment} onClose={this.close} style={{ background: "none" }}>
                    <AddComment showDropdownList={false} shortCommentNote={"Enter a comment below to alert us of any information you'd like us to have for this Payment/DP inquiry."} closeComment={this.close} {...this.props} handleSubmit={this.resolvePaymentWithComment} />
                </Modal>
                <MessageBox {...this.props} box={7} open={this.state.openMsg7} close={this.closeMessage} />
                <MessageBox {...this.props} box={12} size="tiny" open={this.state.openMsg12} close={this.closeMessage} contentTitle="ALERT" content={this.state.message12Content} yesHandle={this.resolve} />
                <MessageBox {...this.props} box={12} size="tiny" open={this.state.openMsg12a} close={this.closeMessage} contentTitle="ALERT" content={this.state.message12Content} yesHandle={null} />
            </div>
        );
    }
}
export default ClientAlert;


// WEBPACK FOOTER //
// ./src/app/ui/alerts/ClientAlert.js